import { ISymbolDetail } from '../../market';

export type TPriceAlertSymbolDetailField =
  | 'bid'
  | 'decimal'
  | 'description'
  | 'open'
  | 'pointStep'
  | 'prevClose'
  | 'symbol'
  | 'tickRulesGroup'
  | 'type';

export type TPriceAlertSymbolDetail = Pick<ISymbolDetail, TPriceAlertSymbolDetailField>;

export interface IPriceAlert extends TPriceAlertSymbolDetail {
  alertId: string;
  targetPrice: number;
  condition: EAlertCondition;
  frequencyCondition: EAlertFrequency;
  status: EAlertStatus;
  toggle: boolean;
}

export interface IInitSymbolPriceAlerts {
  symbol: string;
  alertList: IPriceAlert[];
}

export enum EAlertCondition {
  ABOVE = 'ABOVE',
  BELOW = 'BELOW',
  CROSS_ABOVE = 'CROSS_ABOVE',
  CROSS_BELOW = 'CROSS_BELOW',
  POSITIVE_DAILY_CHANGE_REACHES = 'POSITIVE_DAILY_CHANGE_REACHES',
  NEGATIVE_DAILY_CHANGE_REACHES = 'NEGATIVE_DAILY_CHANGE_REACHES'
}

export enum EAlertFrequency {
  ONLY_ONCE = 'ONLY_ONCE',
  PER_DAY = 'PER_DAY',
  ALWAYS = 'ALWAYS'
}

export enum EAlertStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  TRIGGERED = 'TRIGGERED'
}

export interface IGetPriceAlertsParams {
  cursorId: number;
  limit: number;
}

export const defaultGetPriceAlertsParams: IGetPriceAlertsParams = {
  cursorId: 0,
  limit: 10
};

export interface ICreatePriceAlertParams {
  symbol: string;
  targetValue: number;
  condition: EAlertCondition;
  frequencyCondition: EAlertFrequency;
  toggle?: boolean;
}

export interface IUpdatePriceAlertParams extends Omit<ICreatePriceAlertParams, 'toggle'> {
  alertId: string;
  toggle: boolean;
}

export interface IDeletePriceAlertParams {
  id: string;
}

export interface IBulkDeletePriceAlertsParams {
  ids: string[];
}

export interface IBulkActionResponse {
  successList: string[];
  failList: string[];
}

export interface IPriceAlertConfig {
  symbolLimit: number;
  accountLimit: number;
}

export interface IPriceAlertTriggeredData {
  alertId: string;
  symbol: string;
  traderId: string;
  metatraderId: string;
  targetPrice: number;
  condition: EAlertCondition;
  frequencyCondition: EAlertFrequency;
}
